// eslint-disable-next-line
import React from "react";
import canUseDOM from "./canUseDom";

const NoSSR = ({ children }) => {
  return canUseDOM
    ? typeof children === "function"
      ? children()
      : children
    : null;
};

export default NoSSR;
